/**
 * PR LAB — main entry.
 * Imports SCSS (extracted by Vite to its own CSS bundle) and bootstraps modules.
 */
import '../scss/main.scss';

import { initScrollProgress } from './modules/scroll-progress.js';
import { initObserve } from './modules/observe.js';
import { initLangSwitcher } from './modules/lang-switcher.js';
import { initStickyNav } from './modules/sticky-nav.js';
import { initDashboardParallax } from './modules/dashboard-parallax.js';
import { initFaq } from './modules/faq.js';
import { initShareCopy } from './modules/share-copy.js';
import { initCookieBanner } from './modules/cookie-banner.js';
import { initChipFallback } from './modules/chip-fallback.js';
import { initMobileDrawer } from './modules/mobile-drawer.js';

const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.addEventListener('DOMContentLoaded', () => {
  initStickyNav();
  initScrollProgress();
  initLangSwitcher();
  initFaq();
  initShareCopy();
  initCookieBanner();
  initChipFallback();
  initMobileDrawer();

  if (!REDUCED) {
    initObserve();
    initDashboardParallax();
  } else {
    // Make all observe targets immediately visible.
    document.querySelectorAll('.observe').forEach((el) => el.classList.add('is-visible'));
  }
});
